/* ============================================================
   PREMIUM CART DRAWER
   Intercepts every add-to-cart on the site, posts it with AJAX
   and re-renders the drawer through the Section Rendering API.
   No-ops when the drawer markup is absent, and falls back to a
   normal form submit if the request fails.
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-pm-cart-drawer]');
  if (!root) return;

  var PM = window.PremiumTheme || {};
  var sectionId = root.getAttribute('data-section-id');
  var busy = false;
  var lastFocus = null;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function toast(msg) {
    if (PM && typeof PM.toast === 'function') PM.toast(msg);
  }

  /* ---------- open / close ---------- */

  function open() {
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var close = root.querySelector('[data-pm-cdraw-close]');
    if (close) close.focus();
  }

  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-pm-cdraw-close]')) { e.preventDefault(); close(); return; }
    // click on the scrim (the drawer root itself, outside the panel)
    if (e.target === root) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });

  /* ---------- re-render ---------- */

  function refresh(thenOpen) {
    return fetch(window.location.pathname + '?section_id=' + sectionId, {
      headers: { 'Accept': 'text/html' }
    })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-pm-cart-drawer]');
        if (next) {
          var wasOpen = root.classList.contains('is-open');
          root.innerHTML = next.innerHTML;
          if (wasOpen || thenOpen) open();
        }
        syncCount(doc);
        document.dispatchEvent(new CustomEvent('pm:cart:updated'));
      });
  }

  // Keep the header bag and the bottom-bar badge in step with the drawer.
  function syncCount(doc) {
    var badge = doc && doc.querySelector('.pm-cdraw__count');
    if (!badge) return;
    var n = parseInt(badge.textContent.trim(), 10);
    if (isNaN(n)) return;
    $$('[data-pm-cart-count]').forEach(function (el) {
      el.textContent = n;
      if (el.hasAttribute('hidden') && n > 0) el.removeAttribute('hidden');
      if (n === 0 && el.classList.contains('pm-bbar__n')) el.setAttribute('hidden', '');
    });
  }

  /* ---------- add to cart ---------- */

  function isCartForm(form) {
    var action = form.getAttribute('action') || '';
    return /\/cart\/add/.test(action) || form.hasAttribute('data-pm-quick-form');
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement) || !isCartForm(form)) return;
    if (busy) { e.preventDefault(); return; }

    e.preventDefault();
    busy = true;

    var submit = form.querySelector('[type="submit"]');
    if (submit) { submit.disabled = true; submit.classList.add('is-loading'); }

    var data = new FormData(form);
    data.append('sections', sectionId);

    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: data
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.data && res.data.description) || 'Could not add to bag');
        return refresh(true);
      })
      .catch(function (err) {
        toast(err.message || 'Something went wrong');
      })
      .finally(function () {
        busy = false;
        if (submit) { submit.disabled = false; submit.classList.remove('is-loading'); }
      });
  });

  /* ---------- quantity / remove inside the drawer ---------- */

  function change(line, qty) {
    if (busy) return;
    busy = true;
    fetch((window.routes && window.routes.cart_change_url ? window.routes.cart_change_url : '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refresh(false); })
      .catch(function () { toast('Could not update your bag'); })
      .finally(function () { busy = false; });
  }

  root.addEventListener('click', function (e) {
    var step = e.target.closest('[data-pm-cdraw-qty]');
    if (step) {
      var line = parseInt(step.getAttribute('data-line'), 10);
      var input = root.querySelector('[data-pm-cdraw-qty-input][data-line="' + line + '"]');
      if (!input) return;
      var current = parseInt(input.value, 10) || 0;
      var next = step.getAttribute('data-pm-cdraw-qty') === 'up' ? current + 1 : current - 1;
      if (next < 0) next = 0;
      change(line, next);
      return;
    }

    var rm = e.target.closest('[data-pm-cdraw-remove]');
    if (rm) {
      change(parseInt(rm.getAttribute('data-line'), 10), 0);
    }
  });

  root.addEventListener('change', function (e) {
    var input = e.target.closest('[data-pm-cdraw-qty-input]');
    if (!input) return;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) qty = 0;
    change(parseInt(input.getAttribute('data-line'), 10), qty);
  });

  // let other scripts open it
  window.PremiumCart = { open: open, close: close, refresh: refresh };
})();
